<template>
	<div style="width: 1000px;margin: 70px auto;">
		<bar></bar>
		<div style="width: 1000px;height: 30px;margin-top: 70px;;border-bottom: 1px solid #000000;"><span style="font-size: 14px;float: left">首页/修改密码</span></div>
		<div style="width: 367px;margin: 100px auto;">
			<el-form status-icon  label-width="100px" class="demo-ruleForm">
				<el-form-item label="旧密码"><el-input v-model="ruleForm.age" placeholder="请输入旧密码"></el-input></el-form-item>
				<el-form-item label="新密码"><el-input type="password" v-model="ruleForm.pass" autocomplete="off" placeholder="请输入新密码" show-password></el-input></el-form-item>
				<el-form-item label="密码确认">
					<el-input type="password" v-model="ruleForm.checkPass" autocomplete="off" placeholder="请确认密码" show-password></el-input>
				</el-form-item>
				<el-form-item>	
					<el-button type="primary" @click="submitForm">提交</el-button>
					<el-button @click="resetForm" type="primary">取消</el-button>
				</el-form-item>
			</el-form>
		</div>
	</div>
</template>

<script>
import bar from '@/components/bar.vue'
import { getPassword } from '../api/service'

export default {
	data() {
		var checkAge = (rule, value, callback) => {
			if (!value) {
				return callback(new Error('请输入密码'));
			}
		};
		var validatePass = (rule, value, callback) => {
			if (value === '') {
				callback(new Error('请输入密码'));
			} else {
				if (this.ruleForm.checkPass !== '') {
					this.$refs.ruleForm.validateField('checkPass');
				}
				callback();
			}
		};
		var validatePass2 = (rule, value, callback) => {
			if (value === '') {
				callback(new Error('请再次输入密码'));
			} else if (value !== this.ruleForm.pass) {
				callback(new Error('两次输入密码不一致!'));
			} else {
				callback();
			}
		};
		return {
			input:'',
			ruleForm: {
				pass: '',
				checkPass: '',
				age: ''
			}
		};
	},
	methods: {
		submitForm() {
			if (this.ruleForm.age === '') {
				this.$alert('请输入密码', '提示', {
								confirmButtonText: '确定'
							})
				return
			}
			if (this.ruleForm.pass === '') {
				this.$alert('请输入密码', '提示', {
								confirmButtonText: '确定'
							})
				return
			}
			if (this.ruleForm.checkPass === '') {
				this.$alert('请输入确认密码', '提示', {
								confirmButtonText: '确定'
							})
				return
			}
			if (this.ruleForm.checkPass !== this.ruleForm.pass) {
				this.$alert('两次输入密码不一致', '提示', {
								confirmButtonText: '确定'
							})
				return
			}
			const params = {
						id: this.$store.getters.id,
						oldPwd: this.ruleForm.age,
						newPwd: this.ruleForm.pass
					}
					getPassword(params).then(response => {
						if (response.data.success === true) {
							this.$alert('修改成功', '提示', {
								confirmButtonText: '确定'
								}).then(() => {
									this.$router.push({
										path: '/change'
									});
								})
						} else {
							this.$alert('修改失败', '提示', {
								confirmButtonText: '确定'
							})
						}
					}).catch(() => {
						this.$message({ type: 'warning', message: '修改失败!' })
					})
		},
		resetForm(formName) {
			this.ruleForm.age= ''
			this.ruleForm.pass= ''
			this.ruleForm.checkPass= ''
			this.$router.push({path:'change'});
		}
	},
	components: {
		bar
	}
};
</script>

<style scoped="">
li {
	list-style: none;
}
a {
	text-decoration: none;
}
.meorder-li li {
	display: inline-block;
	margin: 7px 17px 0 30px;
	font-size: 12px;
}
.list-bar-ui {
	text-align: left;
}
.list-bar-ui li {
	list-style: none;
	color: white;
	font-weight: 200;
	margin-left: 20px;
	cursor: pointer;
	display: inline-block;
}
.top-bar {
	position: fixed;
	top: 0;
	bottom: auto;
	left: 0;
	right: auto;
	z-index: 80;
	width: 100%;
}
.top-color {
	height: 40px;
	background: #be0f34;
}
.top-color img {
	float: right;
	width: 209px;
	margin-top: 8px;
	padding-right: 300px;
}

.car-bar-box {
	cursor: pointer;
	width: 30px;
	height: 30px;
	background-image: url(../assets/img/cheo.png);
	background-size: 100%;
	background-repeat: no-repeat;
	position: absolute;
	top: 3px;
	right: 90px;
}
</style>
